
import { Link } from 'react-router-dom'

export default ({ className='', onNav }) => {
  return <Link className={ className } to={ "/dodones/today" } onClick={ onNav }> Today </Link>
}
